import { useContext } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";

import { TasksContext } from "../../context/tasks/store";

import "./style.scss";

type PropsType = {
  children: JSX.Element;
}

export const Modal = ({ children }: PropsType) => {
  const { setIsModalOpen } = useContext(TasksContext);

  return (
    <div className="modal">
      <div className="modal-content">
        <AiOutlineCloseCircle className="close" onClick={setIsModalOpen} />
        {
          children
        }
      </div>
    </div>
  );
};